import { useCallback } from 'react';
import { formatMoney } from '@bookingdei/i18n/format-money';
import { useLanguage } from '../../shell/language-context';
import { useSettings } from '../../shell/settings-context';

// Money for the Home page through packages/i18n (south-asian grouping, Bangla digits
// under bn). `compact` applies the lakh/crore compaction with the long unit words the
// merchant design uses ("৳12.4 lakh"; DR-49 decimals). Symbol and minor-unit scale come
// from the settings registry (API-27), never a literal (INF-1).
export function useHomeMoney(): (minor: number | null | undefined, compact?: boolean) => string {
  const { lang } = useLanguage();
  const { settings } = useSettings();
  const symbol = settings?.currency.symbol ?? settings?.currency.code ?? '';
  const scale = settings?.currency.minor_unit_scale ?? 100;
  return useCallback(
    (minor, compact = false) =>
      minor === null || minor === undefined
        ? '—'
        : formatMoney(lang, minor, { currencySymbol: symbol, minorUnitScale: scale, compact, unitStyle: 'long' }),
    [lang, symbol, scale],
  );
}
